var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 17.5,
    stroke: "var(--button-priority)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84063 8.19625L9.56875 9H8.875L10.0387 5.875H10.8412L12 9H11.2706L10.9987 8.19625H9.84063ZM10.8619 7.73625L10.4375 6.4725H10.4069L9.9825 7.73625H10.8619Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25C7 4.91848 7.1317 4.60054 7.36612 4.36612C7.60054 4.1317 7.91848 4 8.25 4H12.625C12.9565 4 13.2745 4.1317 13.5089 4.36612C13.7433 4.60054 13.875 4.91848 13.875 5.25V7.125H15.75C16.0815 7.125 16.3995 7.2567 16.6339 7.49112C16.8683 7.72554 17 8.04348 17 8.375V12.75C17 13.0815 16.8683 13.3995 16.6339 13.6339C16.3995 13.8683 16.0815 14 15.75 14H11.375C11.0435 14 10.7255 13.8683 10.4911 13.6339C10.2567 13.3995 10.125 13.0815 10.125 12.75V10.875H8.25C7.91848 10.875 7.60054 10.7433 7.36612 10.5089C7.1317 10.2745 7 9.95652 7 9.625V5.25ZM8.25 4.625C8.08424 4.625 7.92527 4.69085 7.80806 4.80806C7.69085 4.92527 7.625 5.08424 7.625 5.25V9.625C7.625 9.79076 7.69085 9.94973 7.80806 10.0669C7.92527 10.1842 8.08424 10.25 8.25 10.25H12.625C12.7908 10.25 12.9497 10.1842 13.0669 10.0669C13.1842 9.94973 13.25 9.79076 13.25 9.625V5.25C13.25 5.08424 13.1842 4.92527 13.0669 4.80806C12.9497 4.69085 12.7908 4.625 12.625 4.625H8.25ZM12.7112 10.8719C12.8317 11.0598 12.9629 11.236 13.105 11.4006C12.6375 11.76 12.0594 12.0262 11.375 12.2081C11.4862 12.3438 11.6569 12.605 11.7219 12.75C12.425 12.5256 13.0219 12.2225 13.5256 11.8162C14.0113 12.2319 14.6125 12.5444 15.3569 12.7362C15.44 12.5775 15.6156 12.3156 15.75 12.18C15.0469 12.0219 14.4644 11.7463 13.9875 11.3775C14.4131 10.9106 14.7512 10.3456 15.0006 9.65438H15.75V9H13.875V9.65438H14.3531C14.1544 10.1819 13.8906 10.6206 13.5581 10.9856C13.4662 10.8878 13.3796 10.7852 13.2987 10.6781C13.1222 10.7909 12.9202 10.8575 12.7112 10.8719Z",
    fill: "var(--button-priority)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAi);
export default __webpack_public_path__ + "static/media/flagAI.0ac07aadd8201e4b14ea969d423ff174.svg";
export { ForwardRef as ReactComponent };